import { ReportOperationObject } from "@core/server/domain/request.interface";
import { ServerResponse } from "@core/server/domain/server.interface";
import {
  addGrowingSeasonApi,
  addReportOperationApi,
  deleteReportOperationApi,
  editGrowingSeasonApi,
  editReportOperationApi,
  getGrowingSeasonsApi,
  getGrwoingSeasonByIdApi,
  getIriigationSystemApi,
  getIrrigationSourceApi,
  getOperationReportsByCategoryIdApi,
  getProductsApi,
} from "@core/server/utils/apis";
import { IrrigationSources } from "@/features/irrigation-sources/domain/irrigation-sources.interface";
import {
  GrowingSeason,
  GrowingSeasons,
  OperationReports,
  Products,
  Season,
} from "@/features/growing-season/domain/growing-season.interface";

export interface GetGrowingSeasonsArguments {
  farmId: string;
  validGrowingSeasons: {
    future: boolean;
    present: boolean;
    past: boolean;
    isBare: boolean;
    date?: string;
  };
}

export interface GetGrowingSeasonArguments {
  farmId: string;
  seasonId: string;
}

export interface AddGrowingSeasonArguments {
  season: Partial<Season>;
  farmId: string;
}

export interface EditGrowingSeasonArguments {
  season: Partial<Season>;
  farmId: string;
  seasonId: string;
}

export interface GetOperationReportsByCategoryIdArguments {
  farmId: string;
  seasonId: string;
  categoryId: number;
}
export interface DeleteReportOperationArguments {
  farmId: string;
  seasonId: string;
  operationReportId: string;
}

export async function getProducts() {
  const response: Promise<ServerResponse<Products> | undefined> =
    await getProductsApi();
  return (await response)?.data.products;
}

export async function getIrrigationSources() {
  const response: Promise<ServerResponse<IrrigationSources> | undefined> =
    await getIrrigationSourceApi();
  return (await response)?.data.irrigationSources;
}

export async function getIrrigationSystems() {
  const response: Promise<ServerResponse<any> | undefined> =
    await getIriigationSystemApi();
  return (await response)?.data?.farmersFields["IRRIGATION_SYSTEM"];
}

export async function getGrowingSeasonById({
  farmId,
  seasonId,
}: GetGrowingSeasonArguments) {
  const response: Promise<ServerResponse<GrowingSeason> | undefined> =
    await getGrwoingSeasonByIdApi({ farmId, seasonId });
  return (await response)?.data.season;
}

export async function getGrowingSeasons({
  farmId,
  validGrowingSeasons,
}: GetGrowingSeasonsArguments) {
  const response: Promise<ServerResponse<GrowingSeasons> | undefined> =
    await getGrowingSeasonsApi({ farmId, validGrowingSeasons });
  return (await response)?.data.seasons;
}

export async function addGrowingSeason({
  season,
  farmId,
}: AddGrowingSeasonArguments) {
  const response: Promise<ServerResponse<Season> | undefined> =
    await addGrowingSeasonApi({ season, farmId });
  return (await response)?.data;
}

export async function editGrowingSeason({
  season,
  farmId,
  seasonId,
}: EditGrowingSeasonArguments) {
  const response: Promise<ServerResponse<Season> | undefined> =
    await editGrowingSeasonApi({ season, farmId, seasonId });
  return (await response)?.data;
}

export async function getOperationReportsByCategoryId({
  farmId,
  seasonId,
  categoryId,
}: GetOperationReportsByCategoryIdArguments) {
  const response: Promise<ServerResponse<OperationReports> | undefined> =
    await getOperationReportsByCategoryIdApi({ farmId, seasonId, categoryId });
  return (await response)?.data.operationReports;
}

export async function addReportOperation({
  farmId,
  seasonId,
  categoryId,
  typeId,
  data,
}: ReportOperationObject) {
  const response: Promise<ServerResponse<string> | undefined> =
    await addReportOperationApi({ farmId, seasonId, categoryId, typeId, data });
  return (await response)?.message;
}

export async function editReportOperation({
  farmId,
  seasonId,
  categoryId,
  typeId,
  data,
  operationReportId,
}: ReportOperationObject) {
  const response: Promise<ServerResponse<string> | undefined> =
    await editReportOperationApi({
      farmId,
      seasonId,
      categoryId,
      typeId,
      data,
      operationReportId,
    });
  return (await response)?.message;
}

export async function deleteReportOperation({
  farmId,
  seasonId,
  operationReportId,
}: DeleteReportOperationArguments) {
  const response: Promise<ServerResponse<string> | undefined> =
    await deleteReportOperationApi({ farmId, seasonId, operationReportId });
  return (await response)?.message;
}
